export interface MarkupPart {
  type: "estimate_values" | "estimate_markups" | "number" | "metric" | "sort_codes" | string;
  estimate_value?: string;
  markup_option?: string;
  operator?: string;
  val?: string;
  uom?: string;
  col?: string;
  sort_code_id?: string;
  sort_field_id?: string;
}

export interface MarkupFormula {
  parts: MarkupPart[];
  total: number;
  overridden: boolean;
}

export interface Allocation {
  type: "sortCodeList" | "all";
  total: number;
  valid: "NOT_VALID" | "ALL_VALID";
  mf?: {
    [key: string]: string[];
  };
  uf?: {
    [key: string]: string[];
  };
  sort_codes?: {
    [key: string]: string[];
  };
}

export interface MarkupData {
  id: string;
  order: number | string;
  value: number | null;
  formula: MarkupFormula | null;
  estimate: string;
  alternate: string | null;
  allocation: Allocation | null;
  created_at: string;
  deleted_at: string | null;
  description: string;
  estimate_use_groups: { [key: string]: any };
  percentage: number;
  updated_at: string;
  total_plus_markups: number;
  totalCumulative: number;
  total_sf_plus_markups: number;
  total_sf: number;
  extras: Record<string, string>;
  mf: Record<string, string>;
  uf: Record<string, string>;
}

export const excludedKeys = new Set<keyof MarkupData>([
  "estimate_use_groups",
  "deleted_at",
  "extras",
  "mf",
  "uf",
  "created_at",
  "updated_at",
  "total_plus_markups",
  "totalCumulative",
  "total_sf",
  "formula",
  "estimate",
  "allocation",
  "percentage",
  "description",
  "total_sf_plus_markups",
]);

export interface Markup extends Omit<MarkupData, keyof typeof excludedKeys> {
  total: number;
  markup_allocation?: number;
  total_plus_markup?: number;
  alternateId?: string;
  alternate_desc?: string;
  alternate_code?: string;
  alternateStatus?: string;
  accepted?: boolean;
  use_group?: string;
  floor_group?: string;
}
